import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function EmploymentTypeList() {
  const navigate = useNavigate();
  const columns = [
    { field: "ES_Id", label: "#" },
    { field: "ES_Name", label: "Employment Type" },
    { field: "ES_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.ES_Id));

        navigate(
          `/EmploymentTypeLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/EmpStatus/list`}
      actions={actions}
      title={`Employment Type`}
      linkvalue={`/EmploymentTypeLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default EmploymentTypeList;
